
export const DateUtil={
	formatDateOnly:(date_string)=>{
		//date_string should be of format yyyy-mm-dd (in UTC)
		if(date_string && date_string.match(/\d{4}-\d{2}-\d{2}/)){
			//let modified=new Date(Date.UTC(date_string.substring(0,4),parseInt(date_string.substring(5,7))-1,date_string.substring(8,10)));
			let modified=new Date(date_string.substring(0,4),parseInt(date_string.substring(5,7))-1,date_string.substring(8,10));
			if(!isNaN(modified))
				return modified.toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric'});
		}
	}
}